// Keeps Settings → Language on the server equal to the interface language.
// Notices in the bell, alert summaries and e-mails are written by the server in
// that language, and the header switcher only changed the browser before.
// One request per sign-in and language (remembered for the browser session).
import { useEffect } from 'react';
import axios from 'axios';
import { API, useAuth } from '../App';
import { useT } from '../i18n';

export default function LocaleSync() {
  const auth = useAuth();
  const uid = auth && auth.user ? auth.user.id : null;
  const { locale } = useT();
  useEffect(() => {
    if (!uid || !locale) return;
    const mark = uid + ':' + locale;
    try {
      if (sessionStorage.getItem('xpnsr_locale_synced') === mark) return;
    } catch (e) {
      /* storage blocked: just send it */
    }
    axios
      .put(API + '/settings/user', { language: locale })
      .then(() => {
        try {
          sessionStorage.setItem('xpnsr_locale_synced', mark);
        } catch (e) {
          /* ignore */
        }
      })
      .catch(() => {});
  }, [uid, locale]);
  return null;
}
